import { _undefined } from '@dinosband/dbi-utils'
import { BvSubscriberManager } from './subscriber-manager'

interface _SubscriptionType {
  unsubscribe(): void
}

export abstract class BvSubscriber<T = unknown> {

  started = false

  protected callback: (value: T | T[]) => void

  private _subscription?: _SubscriptionType

  constructor (callback: (value: T | T[]) => void) {
    this.callback = callback
    BvSubscriberManager.shared.add(this as BvSubscriber<unknown>)
  }

  cleanup () {
    BvSubscriberManager.shared.remove(this as BvSubscriber<unknown>)
    this.stop()
    this.callback = _undefined()
  }

  reconnect () {
    if (this.started) {
      this.stop()
      this.start()
    }
  }

  async start (args?: unknown) {
    this._subscription = await this.subscribe()
    if (this._subscription) {
      this.started = true
    }
    await this.retrieve(args)
  }

  stop () {
    this.started = false
    this._subscription?.unsubscribe()
    this._subscription = undefined
  }

  async retrieve (args?: unknown) {
    const result = await this.query(args)
    if (!result) {
      return
    }
    // if (result instanceof Array) {
    //   result.forEach((value) => this.callback(value))
    // } else {
    this.callback?.(result)
    // }
  }

  protected abstract query (args: unknown): Promise<T | T[] | undefined>
  protected abstract subscribe (): Promise<_SubscriptionType | undefined>

}
